import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const EXPLORE_MARKETS = [
  { label: 'Forex Pairs', to: '/trading/forex-pairs', icon: '💱', gradient: 'linear-gradient(140deg, #1e3a5f, #0d1b2a)' },
  { label: 'Precious Metals', to: '/trading/precious-metals', icon: '🥇', gradient: 'linear-gradient(140deg, #6b5219, #2a2110)' },
  { label: 'Energies', to: '/trading/energies', icon: '🛢️', gradient: 'linear-gradient(140deg, #1f3d3d, #0d1a1a)' },
  { label: 'Indices', to: '/trading/indices', icon: '📊', gradient: 'linear-gradient(140deg, #2a2560, #14122b)' },
  { label: 'Cryptocurrencies', to: '/trading/cryptocurrencies', icon: '₿', gradient: 'linear-gradient(140deg, #6b3a12, #2b1608)' },
]

const ACCOUNT_TABS = ['STD', 'ECN', 'PRO']

function HeroArt({ symbol }) {
  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0 }}>
      <div style={{ position: 'absolute', top: '-20%', right: '-6%', width: '520px', height: '520px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(247,147,26,0.16), transparent 65%)' }} />
      <div style={{ position: 'absolute', bottom: '-30%', left: '10%', width: '420px', height: '420px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(247,147,26,0.08), transparent 65%)' }} />
      {[
        { t: symbol, top: '18%', left: '68%', size: 120, op: 0.06 },
        { t: symbol, top: '55%', left: '85%', size: 70, op: 0.08 },
        { t: symbol, top: '70%', left: '58%', size: 44, op: 0.1 },
      ].map((s, i) => (
        <span key={i} style={{ position: 'absolute', top: s.top, left: s.left, fontSize: s.size, fontWeight: 800, color: `rgba(255,255,255,${s.op})`, fontFamily: fOutfit }}>{s.t}</span>
      ))}
    </div>
  )
}

function DeviceCard({ label, style }) {
  return (
    <div style={{
      position: 'relative', borderRadius: '16px', overflow: 'hidden', minHeight: '240px',
      background: 'linear-gradient(150deg, #12161f, #05070a)', border: `1px solid ${C.dbdr}`,
      boxShadow: '0 24px 48px rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style,
    }}>
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
      <div style={{ position: 'relative', textAlign: 'center', padding: '24px' }}>
        <div style={{ width: '46px', height: '46px', borderRadius: '12px', background: 'rgba(247,147,26,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '20px' }}>📈</div>
        <div style={{ fontSize: '12px', color: C.ltx3, fontFamily: fMono, maxWidth: '220px', margin: '0 auto' }}>{label}</div>
      </div>
    </div>
  )
}

function FaqItem({ q, a, defaultOpen }) {
  const [open, setOpen] = useState(!!defaultOpen)
  return (
    <div style={{ border: `1px solid ${C.bdr}`, borderRadius: '12px', overflow: 'hidden', marginBottom: '10px', background: C.white, boxShadow: open ? '0 8px 20px rgba(0,0,0,0.05)' : 'none', transition: 'box-shadow 0.2s' }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: '100%', textAlign: 'left', background: 'transparent', border: 'none', color: C.tx, fontFamily: fBody,
        fontWeight: 600, fontSize: '13px', padding: '16px 18px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px',
      }}>
        {q}
        <span style={{
          width: '22px', height: '22px', borderRadius: '50%', background: open ? C.primary : C.light, color: open ? C.dark : C.tx3,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', flexShrink: 0, transform: open ? 'rotate(45deg)' : 'none', transition: 'all 0.2s',
        }}>+</span>
      </button>
      {open && <div style={{ padding: '0 18px 18px', fontSize: '13px', color: C.tx2, lineHeight: 1.75 }}>{a}</div>}
    </div>
  )
}

export default function MarketInstrumentPage({
  name, tagline, heroImageLabel, description, descriptionImageLabel,
  conditions, whyTrade, faqs, activeMarket, heroSymbol,
}) {
  const [accountTab, setAccountTab] = useState('STD')
  const activeEntry = EXPLORE_MARKETS.find(m => m.label === activeMarket)

  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xmi-cond-table { width: 100%; border-collapse: collapse; font-size: 13px; }
        .xmi-cond-table th { text-align: left; color: ${C.tx3}; font-weight: 600; font-size: 10px; letter-spacing: 0.06em; text-transform: uppercase; padding: 12px; background: ${C.light}; border-bottom: 1px solid ${C.bdr}; white-space: nowrap; }
        .xmi-cond-table td { padding: 12px; border-bottom: 1px solid ${C.bdr}; color: ${C.tx2}; white-space: nowrap; }
        .xmi-cond-table tbody tr:hover { background: ${C.light}; }
        .xmi-cond-wrap { overflow-x: auto; border: 1px solid ${C.bdr}; border-radius: 14px; box-shadow: 0 4px 16px rgba(0,0,0,0.04); }
        .xmi-why-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 24px; }
        .xmi-explore-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 14px; }
        .xmi-desc-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
        .xmi-explore-tile:hover { transform: translateY(-3px); }
        @media (max-width: 700px) { .xmi-desc-grid { grid-template-columns: 1fr !important; } }
      `}</style>
      <PublicNav active="Trading" />

      {/* HERO — dark, decorative */}
      <section style={{ padding: '130px 24px 60px', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}`, position: 'relative', overflow: 'hidden' }}>
        <HeroArt symbol={heroSymbol} />
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Market Instruments</div>
          <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px', letterSpacing: '-0.02em' }}>{name}</h1>
          <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '480px', marginBottom: '22px', lineHeight: 1.3 }}>{tagline}</p>
          <Link to="/signup" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none', boxShadow: '0 8px 24px rgba(247,147,26,0.25)' }}>Create an Account</Link>
          <div style={{ fontSize: '11px', color: C.ltx3, marginTop: '12px' }}>Trading is risky. Proceed wisely.</div>
        </div>
      </section>

      {/* TRADING CONDITIONS — light */}
      <section style={{ padding: '64px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 24px', color: C.tx }}>{name} Trading Conditions</h2>

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '18px' }}>
          {EXPLORE_MARKETS.map(m => (
            <Link key={m.label} to={m.to} style={{
              fontSize: '12px', padding: '7px 14px', borderRadius: '999px', textDecoration: 'none', fontWeight: 500,
              background: m.label === activeMarket ? C.dark : 'transparent',
              color: m.label === activeMarket ? C.primary : C.tx3, border: `1px solid ${m.label === activeMarket ? C.dark : C.bdr}`,
            }}>{m.label}</Link>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', background: C.light, borderRadius: '10px', padding: '4px', width: 'fit-content' }}>
          {ACCOUNT_TABS.map(t => (
            <button key={t} onClick={() => setAccountTab(t)} style={{
              fontSize: '12px', fontWeight: 700, padding: '8px 18px', borderRadius: '8px', cursor: 'pointer',
              background: accountTab === t ? C.white : 'transparent', color: accountTab === t ? C.tx : C.tx3,
              boxShadow: accountTab === t ? '0 2px 8px rgba(0,0,0,0.08)' : 'none', border: 'none', transition: 'all 0.15s',
            }}>{t}</button>
          ))}
        </div>

        <div className="xmi-cond-wrap">
          <table className="xmi-cond-table">
            <thead>
              <tr>
                <th>Symbol</th><th>Min Spread</th><th>Avg Spread</th><th>Pip Value</th><th>Min Price Movement</th><th>Contract Value</th>
              </tr>
            </thead>
            <tbody>
              {conditions.map(row => (
                <tr key={row.symbol}>
                  <td style={{ color: C.tx, fontWeight: 600 }}>{row.symbol}<div style={{ fontSize: '11px', color: C.tx3, fontWeight: 400 }}>{row.desc}</div></td>
                  <td>{row.minSpread[accountTab]}</td>
                  <td>{row.avgSpread[accountTab]}</td>
                  <td>{row.pipValue}</td>
                  <td>{row.minMove}</td>
                  <td>{row.contractValue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* DESCRIPTION — light, tinted */}
      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light }}>
        <div className="xmi-desc-grid" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div>
            <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, margin: '0 0 16px', color: C.tx, letterSpacing: '-0.01em' }}>{description.title}</h2>
            {description.paragraphs.map((p, i) => (
              <p key={i} style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.3, marginBottom: '14px' }}>{p}</p>
            ))}
            <Link to="/signup" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none' }}>Sign Up</Link>
          </div>
          <DeviceCard label={descriptionImageLabel} />
        </div>
      </section>

      {/* WHY TRADE — dark band */}
      <section style={{ padding: '72px 24px', background: C.dark }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 48px', color: C.ltx }}>Why Trade {name} With Xperia Capital</h2>
        <div className="xmi-why-grid" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {whyTrade.map(w => (
            <div key={w.title} style={{ textAlign: 'center' }}>
              <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <Icon name={w.icon} size={40} strokeWidth={1.4} />
              </div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '20px', lineHeight: 1.1, color: C.ltx, marginBottom: '10px' }}>{w.title}</div>
              <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx3, lineHeight: 1.3, margin: 0 }}>{w.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* EXPLORE OTHER MARKETS — light */}
      <section style={{ padding: '64px 24px', background: C.white }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 28px', color: C.tx }}>Explore Markets</h2>
          <div className="xmi-explore-grid">
            {EXPLORE_MARKETS.map(m => (
              <Link key={m.label} to={m.to} className="xmi-explore-tile" style={{
                display: 'block', textDecoration: 'none', textAlign: 'center', padding: '14px', borderRadius: '14px',
                background: m.gradient, border: m.label === activeMarket ? `2px solid ${C.primary}` : '1px solid transparent',
                color: C.ltx, transition: 'transform 0.2s', boxShadow: '0 10px 24px rgba(0,0,0,0.18)',
              }}>
                <div style={{
                  height: '64px', borderRadius: '8px', border: '1px dashed rgba(255,255,255,0.3)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px',
                  fontSize: '9px', fontFamily: fMono, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.04em',
                }}>[ IMAGE ]</div>
                <div style={{ fontSize: '12px', fontWeight: 600 }}>{m.label}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ — light, tinted */}
      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, margin: '0 0 24px', color: C.tx }}>{name} FAQ</h2>
          {faqs.map((f, i) => <FaqItem key={f.q} q={f.q} a={f.a} defaultOpen={i === 0} />)}
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
